export const environment = {
  production: true,
  urlPrefix: '',
  version: 'b939691eeefeaa22eeb0bd095f283ce1523b4e14',
  defaultLang: 'uk',
  secondaryLang: 'ru',
  name: 'Girko.net',
  phoneMask: '(000) 000-00-00',
  phonePrefix: '',
  currency: 'грн.',
};
